import { defineMessages } from 'react-intl';

export const mlbGlossary = defineMessages({
  pitchers: {
    defaultMessage: 'Pitchers',
  },
  reliefPitchers: {
    defaultMessage: 'Relief Pitchers',
  },
  probablePitcher: {
    defaultMessage: 'Probable Pitcher',
  },
  batters: {
    defaultMessage: 'Batters',
  },
});
